import React, { useState } from 'react';
import Table from '../../table/redux/Table';
import { ApiRiskRule } from '../../api';
import RiskRulesModal from './RiskRulesModal';
import { riskRuleApi } from '../../apis';
import FormattedDateTime from '../../common/datetime/FormattedDateTime';
import { CAN_ADD_RISK_RULE, CAN_MODIFY_RISK_RULE } from '../../auth/permissions';
import Has from '../../auth/Has';
import { Button } from '@salvapp/ui-components';
import SalvPage from '../../common/SalvPage';
import { getConfigurationUrl, getRiskRulePath } from '../../navigation/helper';
import { useNavigate } from 'react-router';
import { ConfigurationProduct } from '../../settings/configuration/Configuration';

export function RiskRules() {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const fetchRiskRules = (page: number, size: number, query?: string) => {
    return riskRuleApi.findAllRiskRules({ page, size, query });
  };
  const onComplete = async () => {
    setShowModal(false);
  };

  const addRiskRule = async () => {
    setShowModal(true);
  };

  const editRiskRule = async (riskRule: ApiRiskRule) => {
    navigate(getRiskRulePath(riskRule.handle!));
  };

  return (
    <SalvPage
      title={'Risk assessment rules'}
      breadcrumb={{
        title: 'Configuration',
        to: getConfigurationUrl(ConfigurationProduct.RISK),
      }}
    >
      <Table<ApiRiskRule>
        hover={false}
        name='riskRules'
        fetchContent={fetchRiskRules}
        actions={() => (
          <>
            <Has allPermissions={CAN_ADD_RISK_RULE}>
              <Button variant='white' size='small' onClick={() => addRiskRule()}>
                Add new rule
              </Button>
            </Has>
          </>
        )}
        searchable
        header={() => (
          <tr>
            <th>Reason</th>
            <th>Details</th>
            <th>Weight</th>
            <th>Date added</th>
            <th>Status</th>
            <th>Author</th>
            <th className='text-end'>Actions</th>
          </tr>
        )}
        body={(riskRules) =>
          riskRules.length > 0 &&
          riskRules.map((rule) => (
            <tr key={rule.id}>
              <td>{rule.reason}</td>
              <td>{rule.details}</td>
              <td>{rule.weight}</td>
              <td>
                <FormattedDateTime date={rule.createdTime} />
              </td>
              {rule.endTime ? (
                <td className='text-secondary'>Archived</td>
              ) : rule.enabled ? (
                <td className='text-success'>Active</td>
              ) : (
                <td className='text-danger'>Inactive</td>
              )}
              <td>{rule.user && rule.user.name}</td>
              <td className='text-end'>
                <Button
                  onClick={() => editRiskRule(rule)}
                  variant='outline-danger'
                  className='right-button'
                  size='small'
                >
                  <Has allPermissions={CAN_MODIFY_RISK_RULE}>{(access: boolean) => (access ? 'Edit' : 'View')}</Has>
                </Button>
              </td>
            </tr>
          ))
        }
      />
      <RiskRulesModal show={showModal} onComplete={onComplete} />
    </SalvPage>
  );
}

export default RiskRules;
